
import { computed, defineComponent, onMounted, reactive, ref, watch } from "vue";
import LoginTab from "@/components/login/LoginTab.vue";
import NavTop from "@/components/NavTop.vue"
import { authLogin, checksmscode, checkuser, getquhaolist, getwebvideolist, loginpass, sendsms } from '@/api';
import { message } from 'ant-design-vue';
import router from '@/router';
import { useI18n } from '@/utils/i18n';
import store from '@/store';
import { getValue, saveValue } from '@/utils/common';
import { locale } from "dayjs";
import { setToken } from "@/api/base";

export default defineComponent({
  name: "Login",
  components: {
    LoginTab,
    NavTop
  },
  setup() {
    const lan: any = useI18n();
    const formLayout = {
      labelCol: 4,
      wrapperCol: 14,
    };
    const tabselected = ref(1);  //tab切换的标志
    const time = ref(60);//倒计时
    const phone = ref(""); // 手机号
    const code =ref("")
    
    const userinfo = reactive({
      phone: '',
      password: ''
    })
    const mrqh = computed(() => store.state.qh)
    const hqqh = computed(() => { console.log(mrqh.value.name  + '+' + mrqh.value.code); return (getValue("Lanvuage") == "en"  ?mrqh.value.ename : mrqh.value.name) + '+' + mrqh.value.code  })
    const quhaolist = ref<any>([
    {
      code: "86",
      id: 214,
      name: "中国"
    }
    ])
    const myquhao=ref(mrqh.value.code)
    watch(mrqh,()=>{
      myquhao.value = mrqh.value.code
    })
    const videolist=ref<any>([])

    onMounted(async ()=>{
        quhaolist.value=await getquhaolist()
        videolist.value=await getwebvideolist()
        console.log(videolist.value,"listsssss")
    })


    /**
     * @param val  子组件传过来的值
     */
    const Selectnum: (val: number) => void = (val: number) => {
      console.log("收到子组件事件", val);

      tabselected.value = val;
    };

    /**
     * @param 
     * 点击获取验证码 触发倒计时
     */
     let lock=false
    async function getcode() {
      console.log(phone.value);
         if (lock) {
          console.log("lock")
          return;
        }
        if (phone.value == "") {
            message.error(lan.$t('shoujihaoweikong'));
            return;
        }
        const iszc: any =  await checkuser({phone: phone.value})
        if(iszc.data){
            if(iszc.data.identity == 0){
              message.error(lan.$t("yizhucexuesheng"))
              return ;
            }
        }
        lock = true;
        console.log(myquhao.value,"quhao")
        sendsms(myquhao.value, phone.value);
        const timestep = setInterval(() => {
        console.log(11112);
     
        

        time.value = time.value - 1;
        if (time.value > 0) {
          console.log();
        } else {
          time.value = 60;
          clearInterval(timestep);
        }
      }, 1000);
    }
    function getquhao(e?: any){
            console.log(e)
            myquhao.value = e.toString()
            myquhao.value = myquhao.value.split("+")[1];
            console.log(myquhao.value)
        }
    function login(): void {
        console.log(userinfo.phone,userinfo.password)
      if(userinfo.phone==''){
        message.error(lan.$t('zhanghaoweikong'))
      } else if(userinfo.password==""){
        message.error(lan.$t('mimaweikong'))
      }else{
        loginpass(userinfo.phone,userinfo.password)
      }
        

    }

    function sublogin(){
      console.log(11)
      // else if(!(/^1[3-9]\d{9}$/.test(phone.value))){ 
      //   message.error(lan.$t('shoujihaoyouwu'));  
      //   return
      // }
      if(phone.value==''){
        message.error(lan.$t('shoujihaoweikong'))
        return
      } else if(code.value==""){
        // console.log(phone.value)
        console.log((/^1[3-9]\d{9}$/.test(phone.value)))
        message.error(lan.$t('yanzhengmaweikong'))
        return
      }else{
        loginpass(myquhao.value + phone.value,'',1,code.value)
      }
      // checksmscode(myquhao.value+phone.value,code.value)
      
    }

    function tovideoxq(e?: number){
      console.log(e)
      router.push("/regime/videoinfo?id="+e)
    }

    function navto(){
      router.push("/about")
    }
    
    function slogin(index: number){
      console.log(index)
      if(index == 3){
        window.FB.login(function(response: any){
          console.log(response, 121212)
          // handle the response 
          authLogin(response.authResponse.userID, index).then((res: any)=>{
            if(res.redirect == 1){
              sessionStorage.setItem('mid',res.memberid);
              router.push("/sign")
              
            }else{
              if(!saveValue("token", res.api_token) && !saveValue("memberid", res.memberid) ){
                  message.error("存储错误, 请允许网页使用本地存储！")
                  return false;
              }else{
                  setToken();
                  store.commit("login", true);
                  store.dispatch("setUserInfo");
                  router.push("/mine/archives")
        }
            }
          })
        });

      }
      if(index == 2){
        window.location.href="https://api.weibo.com/oauth2/authorize?client_id=2754574056&response_type=code&redirect_uri=https://www.beelinkco.com/teacher/wblogin"
      }
      if(index == 1){
        window.location.href=`https://open.weixin.qq.com/connect/qrconnect?appid=wx90b8841b63a86633&redirect_uri=${escape('https://www.beelinkco.com/teacher/wxlogin')}&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect`

      }
    }
    const text = computed(()=> store.state.infotext)
    return {
      formLayout,
      tabselected,
      Selectnum,
      getcode,
      time,
      phone,
      login,
      userinfo,
      quhaolist,
      getquhao,
      code,
      myquhao,
      sublogin,
      videolist,
      tovideoxq,
      navto,
      lan,
      slogin,
      mrqh,
      hqqh,
      text
    };
  },
});
